// @ts-nocheck
import { isArray } from 'lodash';

export const mergeAttNId = <ATT, ID>(
  obj?: { attributes?: ATT | null | undefined; id?: ID | null | undefined } | null | undefined,
): ATT & { id?: ID | null } => {
  if (!isPlainObject(obj)) return obj;
  const { attributes, ...rest } = obj;
  const r = {
    ...rest,
    ...attributes,
  };
  return r;
};

export const mai = mergeAttNId;

const isPlainObject = (obj) => obj && obj.constructor === Object && Object.getPrototypeOf(obj) === Object.prototype;

const extractDataOrReturn = (obj) => {
  const { data, ...rest } = obj;

  if (isArray(data)) {
    const newArray = [];
    const arrayofhoisted = data.map((d) => mai(d));
    for (const [k, v] of Object.entries(rest)) {
      newArray[k] = v;
    }
    // override what's in `data` with what's in `attributes` in calse of clash
    for (const [k, v] of Object.entries(arrayofhoisted)) {
      newArray[k] = v;
    }
    return newArray;
  } else if (isPlainObject(data)) {
    const hoisted = mai(data);
    // override what's in `data` with what's in `attributes` in calse of clash
    const newObj = { ...rest, ...hoisted };
    return newObj;
  }

  return obj;
};

export const v4tov3base = (obj) => {
  if (!(isArray(obj) || isPlainObject(obj))) {
    return obj;
  }
  const onelevelflat = extractDataOrReturn(obj);

  // console.log(obj, onelevelflat);
  // first level done, go to child objects
  let newObject = {};
  if (isArray(onelevelflat)) {
    newObject = [];
  }
  for (const [k, v] of Object.entries(onelevelflat)) {
    newObject[k] = v4tov3base(v);
  }

  return newObject;
};

export const v4tov3 = (obj) => {
  const { strapi, ...rest } = obj;
  return {
    strapi: v4tov3base(strapi),
    ...rest,
  };
};

export type WithID<T, TID> = T & { id: TID };

// TODO use this for tests
/***
 * {
  strapi: {
    extra: 100,
    blogPosts: {
      data: {
        attributes: {
          name: 'Blog-1',
          data: 'fake-data',
          categories: [
            {
              __typename: 'Cat',
              data: {
                attributes: {
                  name: 'cat2',
                },
              },
            },
          ],
        },
      },
    },
  },
}
 */
